module.exports = __webpack_public_path__ + "img/equipment.fe5e7d99.svg";